import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationNozzlesPerSide
} from 'services/equipmentSets/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { makeSelectNozzlesPerSide } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    calibrationId: CalibrationId;
}

interface ConnectedProps {
    nozzlesPerSide: CalibrationNozzlesPerSide;
}

type Props = OwnProps & ConnectedProps;

export class NozzlesPerSideTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { nozzlesPerSide } = this.props;

        return <TableCell>{nozzlesPerSide}</TableCell>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    nozzlesPerSide: makeSelectNozzlesPerSide()
});

export default connect(mapStateToProps)(NozzlesPerSideTableCellComponent);
